import { validator } from '@ally/validator';
var NotSameAccount = function (_, _a) {
    var _b = _a.values, fromAccount = _b.fromAccount, toAccount = _b.toAccount;
    return fromAccount !== toAccount;
};
export var NotSameAccountErrorMessage = 'Your From and To accounts must be different.';
export var NotSameAccountValidator = validator(NotSameAccount, NotSameAccountErrorMessage);
//# sourceMappingURL=NotSameAccount.js.map